export default "__VITE_ASSET__B2PaW0nY__"